// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".progress-table{position:absolute;z-index:1;border-radius:0;opacity:1;background:#ffffff50;height:8px;width:100%}\n", ""]);
// Exports
module.exports = exports;
